<template>
    <div id="VueFooter" class="footer-main branding-bg" data-trackname="footer">
        <div class="container container-kernel">
          <p>© {{year}} Nedgia</p>
        </div>
    </div>
</template>

<script>
export default {
  name: 'VueFooter',
  data: function () {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Layout/Footer.vue